import { z } from 'zod';
import { IssueKeySchema, TimestampSchema } from './common.js';
import { UserRefSchema } from './domain.js';
/**
 * Уведомления: что случилось с задачами, которые касаются лично тебя.
 *
 * Два повода, и оба взяты из Jira, а не заведены в Jisy: чужой комментарий к задаче, где ты
 * исполнитель или автор, и новая задача, назначенная на тебя кем-то другим. Своих действий
 * среди уведомлений нет — о собственном комментарии сообщать некому.
 *
 * Список показывает только непрочитанное. Прочитанное не хранится и не листается: это не
 * лента событий, а напоминание о том, что ещё не посмотрели.
 */
/** Насколько глубоко в прошлое смотрим. Дальше — уже не уведомление, а история задачи. */
export const NOTIFICATIONS_WINDOW_DAYS = 14;
/** Потолок выдачи. Больше полусотни в поповере всё равно не просмотреть. */
export const NOTIFICATIONS_LIMIT = 50;
/** Длина выдержки из комментария в строке списка. */
export const NOTIFICATION_EXCERPT_LENGTH = 160;
export const NotificationKindSchema = z.enum(['comment', 'assigned']);
export const NotificationSchema = z.object({
    /** `comment:<id>` или `assigned:<ключ задачи>` — устойчив между запросами. */
    id: z.string(),
    kind: NotificationKindSchema,
    issueKey: IssueKeySchema,
    issueSummary: z.string(),
    projectKey: z.string(),
    /** Кто это сделал: автор комментария или автор задачи. */
    actor: UserRefSchema.nullable(),
    /** Выдержка из комментария; у назначения пусто — там всё сказано названием задачи. */
    excerpt: z.string(),
    createdAt: TimestampSchema,
});
export const NotificationListSchema = z.object({
    items: z.array(NotificationSchema),
    /**
     * Сколько непрочитанного всего. Отличается от длины списка, когда упёрлись в потолок:
     * счётчик на колокольчике тогда показывает «50+», а не врёт про ровно пятьдесят.
     */
    unread: z.number().int().nonnegative(),
});
/**
 * Отметка о прочтении. Хранится не по каждому уведомлению, а моментом на задачу: всё, что в
 * ней случилось раньше этого момента, прочитано. Поэтому открытая карточка гасит сразу все
 * комментарии задачи, и список отметок не растёт вместе с числом комментариев.
 */
export const NotificationsReadSchema = z
    .object({
    issueKeys: z.array(IssueKeySchema).max(200).optional(),
    /** «Прочитать все» — общий рубеж по пользователю, отметки по задачам после него не нужны. */
    all: z.boolean().optional(),
})
    .refine((input) => input.all === true || (input.issueKeys?.length ?? 0) > 0, 'нужны ключи задач или признак all');
//# sourceMappingURL=notifications.js.map